import React, { Fragment, useState, useEffect } from 'react';
import { Box, Button, CardMedia, Divider, Grid, Typography, CircularProgress, IconButton } from '@mui/material';
import Colors from '../../../Assets/Styles/Colors';
import BreadCrumbs from '../../../Components/BreadCrumbs/BreadCrumbs';
import AdGuruServices from '../../../Api/AdGuru/AdGuruServices';
import CategoriesServices from '../../../Api/AdBazar/Categories/CategoriesServices';
import SearchField from '../../../Components/Fields/SearchField';
import { CalendarMonth, Delete, KeyboardArrowLeft, WorkspacesOutlined } from '@mui/icons-material';
import { PrimaryButton } from '../../../Components/Buttons';
import { CircleLoading } from '../../../Components/Loaders/CircleLoading';
import { baseUrl } from '../../../../axios';
import Images from '../../../Assets/Images/Images';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import ConfirmationDialog from '../../../Components/Dialogs/ConfirmationDialog';
import AdleaksServices from '../../../Api/AdLeak/AdleaksServices';
import { SuccessToaster } from '../../../Components/Toaster/Toaster';

function AdGuruListing() {
  const [allAdguru, setAllAdguru] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [totalCount, setTotalCount] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [catLoading, setCatLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(false);
  const navigate = useNavigate();

  const getAllAdguru = async (catId, searchKey, page, rows) => {
    setLoading(true);
    try {
      const result = await AdGuruServices.getAdGuru(
        catId ? catId : null,
        searchKey ? searchKey : "",
        page ? page : 1,
        rows ? rows : 10,
        "adguru"
      );
      console.log("result =>", result);
      setAllAdguru(result?.data?.blogs);
      setTotalCount(result?.data?.pageInfo?.totalBlogs);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const getAllCategories = async (searchKey) => {
    setCatLoading(true);
    try {
      const result = await CategoriesServices.getAllCategories(searchKey ? searchKey : "", 1, 100, "adguru");
      const filteredCategories = result?.data?.categories?.filter((item) =>
        item.isActive == true
      );
      setCategories(filteredCategories);
    } catch (error) {
      console.log(error);
    } finally {
      setCatLoading(false);
    }
  }

  const handleLoadMore = async (event) => {
    event.preventDefault(); // Prevent page refresh
    setBtnLoading(true);
    try {
      const nextPage = page + 1;
      const result = await AdGuruServices.getAdGuru(
        selectedCategory,
        "",
        nextPage,
        limit,
        "adguru"
      );
      setAllAdguru((prevAdguru) => [...prevAdguru, ...result?.data?.blogs]);
      setTotalCount(result?.data?.pageInfo?.totalBlogs);
      setPage(nextPage);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      const result = await AdleaksServices.deleteBlog(id);
      if (result.responseCode == 200) {
        SuccessToaster(result.message)
      }
    } catch (err) {
      console.log(err);
    } finally {
      getAllAdguru();
    }
  }

  useEffect(() => {
    getAllAdguru("", "", page, limit);
    getAllCategories();
    setSelectedCategory("")
  }, [])

  return (
    <Fragment>
      <ConfirmationDialog
        open={open}
        onClose={() => setOpen(false)}
        title={"Delete Blog"}
        action={handleDelete}
        btn={"Delete"}
        secBtn={"Cancel"}
        secAction={() => setOpen(false)}
      />
      <Box
        sx={{
          borderRadius: "12px",
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{
            background: Colors.primaryGradient,
            p: 2,
            borderRadius: "12px",
          }}
        >
          <Grid item xs={6}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <IconButton onClick={() => navigate(-1)}>
                <KeyboardArrowLeft sx={{ color: Colors.white }} />
              </IconButton>
              <Typography variant="body1" fontWeight="bold" sx={{ color: Colors.white }}>
                Adguru List
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage={["Adguru List"]} />
          </Grid>
        </Grid>

        <Box sx={{ backgroundColor: Colors.white, mt: "20px", borderRadius: "12px" }}>
          <Grid container>

            <Grid item md={3} sx={{ backgroundColor: "#F8F8F8", borderRadius: "12px" }}>
              <Box
                sx={{
                  px: "18px",
                  py: "20px",
                  position: "sticky",
                  top: "10%"
                }}
              >
                <Typography variant="body1" sx={{ mb: "10px" }}>
                  Filter by Category
                </Typography>
                <Box sx={{ pb: "20px", my: 1.3, width: "100%" }}>
                  <SearchField searchKey={(key) => getAllCategories(key)} />
                </Box>
                <Box
                  sx={{
                    borderRadius: "13px",
                    px: "13px",
                    py: "4px",
                    mb: "15px",
                  }}
                >
                  <Box sx={{ display: "flex" }}>
                    <WorkspacesOutlined
                      sx={{ mr: "6px", fontSize: "20px", py: "2px" }}
                    />
                    <Box sx={{ py: "3px" }}>
                      <Typography variant="body2">Categories</Typography>
                    </Box>
                  </Box>
                </Box>
                {catLoading ? (
                  <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <CircularProgress />
                  </Box>
                ) : (
                  <Box>
                    <Box sx={{ height: "265px", overflowY: "auto" }}>
                      <Box
                        sx={{
                          px: "14px",
                          py: "10px",
                          mb: 1,
                          cursor: "pointer",
                          backgroundColor: selectedCategory === "" ? Colors.primary : "transparent",
                          color: selectedCategory === "" ? Colors.white : Colors.black,
                          borderRadius: "13px",
                          ":hover": {
                            backgroundColor: Colors.primary,
                            color: Colors.white,
                            overflow: "hidden",
                          },
                        }}
                        onClick={() => {
                          getAllAdguru("");
                          setSelectedCategory("");
                          // getSubCategory(item?._id)
                        }}
                      >
                        <Typography variant="body2">All</Typography>
                      </Box>
                      {categories.map((item, index) => (
                        <Box
                          key={index}
                          sx={{
                            px: "14px",
                            py: "10px",
                            mb: 1,
                            cursor: "pointer",
                            backgroundColor: selectedCategory === item._id ? Colors.primary : "transparent",
                            color: selectedCategory === item._id ? Colors.white : Colors.black,
                            borderRadius: "13px",
                            ":hover": {
                              backgroundColor: Colors.primary,
                              color: Colors.white,
                              overflow: "hidden",
                            },
                          }}
                          onClick={() => {
                            getAllAdguru(item?._id);
                            setSelectedCategory(item?._id);
                            // getSubCategory(item?._id)
                          }}
                        >
                          <Typography variant="body2">{item.name}</Typography>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                )}
              </Box>
            </Grid>
            <Grid item md={9} sx={{ padding: "0px" }}>
              <Box
                sx={{
                  px: "18px",
                  py: "20px",
                }}
              >
                {loading ? <CircleLoading /> : (
                  <Fragment>
                    <Box sx={{ width: "25%", mx: 3 }}>
                      <SearchField searchKey={(key) => getAllAdguru("", key, "", "")} />
                    </Box>
                    <Grid container>
                      {allAdguru ? (
                        <Fragment>
                          {allAdguru?.length > 0 ? (
                            <Fragment>
                              {allAdguru.map((item, index) => (
                                <Grid key={index} item md={6} sx={{ pl: "25px", py: 1.8 }}>
                                  <Box
                                    sx={{
                                      p: 0.5,
                                      borderRadius: "9px",
                                      boxShadow: "0px 2px 8px #d8d8d87a",
                                      background: "#fff",
                                      ":hover": {
                                        ".dlt-btn": {
                                          display: "flex"
                                        }
                                      },
                                      position: "relative",
                                    }}
                                  >
                                    <Box>
                                      <CardMedia
                                        component={"img"}
                                        src={baseUrl + item.image}
                                        sx={{ width: "100%", height: "185px", objectFit: "contain" }}
                                      />
                                    </Box>
                                    <Grid container alignItems={"center"} p={"0px 10px 10px 10px"}>
                                      <Grid item md={12}>
                                        <Box>
                                          <Typography variant='body1' sx={{ fontWeight: "bold" }}>
                                            {item?.title}
                                          </Typography>
                                        </Box>
                                      </Grid>
                                      <Grid item md={6}>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                          <CalendarMonth sx={{ color: Colors.primary }} />
                                          <Typography
                                            sx={{
                                              color: "#ACACAC",
                                            }}
                                            variant="caption"
                                          >
                                            {moment(item?.date).format("DD-MM-YYYY")}
                                          </Typography>
                                        </Box>
                                      </Grid>
                                      <Grid item md={6}>
                                        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: "5px" }}>
                                          <Button
                                            variant={"outlined"}
                                            onClick={() => navigate(`/adguru-edit/${item?._id}`, { state: item })}
                                          >
                                            Edit
                                          </Button>
                                        </Box>
                                      </Grid>
                                    </Grid>
                                    <IconButton
                                      onClick={() => {
                                        setOpen(true);
                                        setId(item?._id);
                                      }}
                                      className='dlt-btn'
                                      sx={{
                                        background: Colors.primary,
                                        ":hover": {
                                          background: Colors.primary,
                                        },
                                        position: "absolute",
                                        top: 0,
                                        right: 0,
                                        display: "none",
                                        height: "40px",
                                        width: "40px"
                                      }}
                                    >
                                      <Delete sx={{ color: Colors.white }} />
                                    </IconButton>
                                  </Box>
                                </Grid>
                              ))}
                            </Fragment>
                          ) : (
                            <Box
                              sx={{
                                width: 1,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Typography variant="h6">No data found</Typography>
                            </Box>
                          )}
                        </Fragment>
                      ) : (
                        <Box sx={{ width: 1, textAlign: "center" }}>
                          <CircleLoading />
                        </Box>
                      )}
                    </Grid>
                    <Box
                      sx={{
                        display: "flex", justifyContent: "center"
                      }}
                    >
                      {totalCount !== allAdguru?.length && (
                        <PrimaryButton
                          title={"Load More"}
                          loading={btnLoading}
                          onClick={(e) => handleLoadMore(e)}
                        />
                      )}
                    </Box>
                  </Fragment>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Fragment >
  )
}

export default AdGuruListing